import { createContext, useContext } from 'react';
import { SiteName } from 'types/Site';

const SiteContext = createContext<SiteName | null>(null);

export const getSite = (): SiteName => {
  const context = useContext(SiteContext);
  if (!context) {
    throw new Error('useSite must be used within a SiteContext.Provider');
  }
  return context;
};

export { SiteContext };
